import script from "./OtpInput.vue?vue&type=script&setup=true&lang=js"
export * from "./OtpInput.vue?vue&type=script&setup=true&lang=js"

import "./OtpInput.vue?vue&type=style&index=0&id=4a6e206c&scoped=true&lang=css"

import exportComponent from "/trc/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a6e206c"]])

export default __exports__